/**
 * Created by rhinov15 on 17/03/2016.
 *
 *  Graphical node representing a picture window placed in the 2d scene
 */

import { JoineryNode } from "../JoineryNode";
import { PlanManager } from "../../../../../cocosPlan";
import { PictureWindow, SceneConstants } from "@rhinov/savane-js";

declare var cc: any;

export class PictureWindowNode extends JoineryNode {

    //@private
    protected _nbDoors = 1;
    //@private
    protected _slideDirection = SceneConstants.SlideDirection.slide_left;

    constructor(jDoor: PictureWindow){
        super(jDoor);
        // Create and assign sprite to the node
        this.computeModel(jDoor);
    }

    // Getters & Setters
    getNbDoor(): number {
        return this._nbCasment;
    }

    setNbDoor(value: number) {
        this._nbCasment = value;
    }

    getSlideDirection(): number  {
        return this._slideDirection;
    }

    setSlideDirection(value: number) {
        this._slideDirection = value;
    }

    // This loads the sprite image depending on entity parameters
    computeModel(joinery: PictureWindow) {
        // If the associated entity exists
        if (joinery !== undefined) {
            // Retrieve joinery parameters and store them into this object
            this._nbDoors = joinery.nbDoors;
            this._length = joinery.length;
            if (joinery.wall != null) {
                this._thickness = joinery.wall.thickness;
            }
            else {
                this._thickness = this._length / 10;
            }
            this._slideDirection = joinery.slideDirection;
            this._wallInstallTye = joinery.wallInstallType;
            this._handleSide = joinery.handleSide;
        }

        // This is commented since useless further (we can remove this code if we don't want sprite mip map)
        /*
        //var idealSize = (this._length / 10 / this._nbDoors) * PlanManager.getInstance().getZoomScale();
        //var foundSize = Utils.getClosestNumberInArray(idealSize, JoineryNode.ImageSizeExtentions);
        ////console.log(foundSize);
        //if (foundSize === 0)
        //{
        //    foundSize = JoineryNode.ImageSizeExtentions[0];
        //}
        */

        // Create one sprite per door
        for (var i = 0; i < this._nbDoors; ++i) {
            var sprite = new cc.Sprite();
            // Load correct sprite (window for 2 doors, bayBot for 1 door)
            var spriteName = this._nbDoors > 1 ? (i % 2 == 0 ? 'plan/bayBot.png' : 'plan/bayBot.png') : 'plan/bayBot.png';
            // Load sprite image
            sprite.initWithSpriteFrameName(spriteName);
            // Set sprite anchor
            sprite.setAnchorPoint(new cc.p((i + 1) - (this._nbDoors * 0.5), 0));
            if (this.transparentDraw) {
                sprite.setOpacity(64);
            }
            // Sprite scale X and Y
            sprite.setScaleX(this._length / (sprite.width * 10 * this._nbDoors));
            sprite.setScaleY(0.26);

            var y = this._thickness * 0.1;
            sprite.setPositionY(this.getY(10));
            // Sprite name
            sprite.setName('door-' + i);
            // Add the sprite to the node
            this.addChild(sprite, 8);
        }

    }

    getY(h: number): number | undefined {
        switch (this._wallInstallTye) {
            case 1:
                return -(this._thickness * 0.1) * 0.5;
                break;

            case 0:
                return (-h * 0.5);
                break;

            case -1:
                return ((this._thickness * 0.1) * 0.5 - 10);
                break;
        }
    }

    // Draw background rectangles
    drawOverlap(joinery: PictureWindow, isValid: boolean) {
        var alpha = 255;
        if (this.transparentDraw) {
            alpha = 64;
        }
        // Clear the node content
        this.clear();

        if (this._thickness > 0) {
            // Compute width and height of the box to draw
            var h = (this._thickness * 0.1);
            var w = this._length * 0.1 - 1;
            var y = -h * 0.5;
            var x = -w * 0.5;

            // Drawing color
            var color: {border: any, plain:any} = {border: undefined, plain: undefined};

            if (isValid !== undefined) {
                color = this.getOverLapColor(isValid);
            }
            else {
                color = this.getOverLapColor(true);
            }

            // Size of the border (depends on the zoom value)
            var borderSize = 1;
            if (borderSize * PlanManager.getInstance().getZoomScale() < 1) {
                borderSize /= PlanManager.getInstance().getZoomScale();
            }

            var white = new cc.color(255, 255, 255, alpha);
            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), white, borderSize, white);

            // Default door thickness
            h = (100 * 0.1);

            y = this.getY(h) as number;

            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), color.plain, borderSize, color.border);
            this.drawRect(new cc.p(x - 0.5, y - 0.5), new cc.p(x + w * 0.015, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
            this.drawRect(new cc.p(x + w - w * 0.015, y - 0.5), new cc.p(x + w + 0.5, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));

            var val2 = 0.040;

            if (this._nbDoors === 1 && this._handleSide !== SceneConstants.HandleSide.handle_left) {
                this.drawRect(new cc.p(x + (w * 0.1) - borderSize * 0.5, y - (h / 4) + borderSize * 0.5),
                    new cc.p(x + (w * 0.04) + borderSize * 0.5, y + borderSize * 0.5),
                    new cc.Color(66, 80, 94, alpha), borderSize, new cc.Color(66, 80, 94, alpha));
            }
            else {
                this.drawRect(new cc.p(x + w - (w * 0.1) - borderSize * 0.5, y - (h / 4) + borderSize * 0.5),
                    new cc.p(x + w - (w * 0.04) + borderSize * 0.5, y + borderSize * 0.5),
                    new cc.Color(66, 80, 94, alpha), borderSize, new cc.Color(66, 80, 94, alpha));
            }
        }
    }

    // Update node content
    updateModel(joinery: PictureWindow, isValid: boolean) {
        this.removeAllChildren();
        this.computeModel(joinery);
        super.updateModel(joinery, isValid);
        this.drawOverlap(joinery, isValid);
    }
}
